import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { useDispatch, useStore } from 'react-redux';
import { getDisplayName, getDataDependency } from 'gandi.react-helpers';
import { useEntityPermissions } from '../hooks/useEntityPermissions';
import { entitiesResource } from '../modules/resources/entities';
import { jsx as _jsx } from "react/jsx-runtime";
export const withEntityPermissions = requestedPermissionsCallback => WrappedComponent => {
  function WithEntityPermissions(props) {
    const dispatch = useDispatch();
    const store = useStore();
    const standardizedProps = React.useMemo(() => ({
      ...props,
      dispatch,
      getState: store.getState
    }), [dispatch, props, store.getState]);
    const requestedPermissions = requestedPermissionsCallback(standardizedProps);
    const {
      hasPermissions,
      isFetchingPermissions,
      isLoadedPermissions
    } = useEntityPermissions(requestedPermissions.entity);
    const entityPermissions = Object.entries(requestedPermissions.hasPermissions).reduce((acc, [key, permissions]) => {
      acc[key] = hasPermissions(permissions);
      return acc;
    }, {});
    return /*#__PURE__*/_jsx(WrappedComponent, {
      ...props,
      isFetchingPermissions: props.isFetchingPermissions || isFetchingPermissions,
      isLoadedPermissions: (props.isLoadedPermissions || true) && isLoadedPermissions,
      permissions: {
        ...props.permissions,
        ...entityPermissions
      }
    });
  }
  const HoistedComponent = hoistNonReactStatic(WithEntityPermissions, WrappedComponent);
  HoistedComponent.WrappedComponent = WrappedComponent;
  HoistedComponent.displayName = `WithEntityPermissions(${getDisplayName(WrappedComponent)})`;
  const wrappedPreFetch = getDataDependency(WrappedComponent, 'preFetch');
  HoistedComponent.preFetch = async function preFetch(args) {
    const requestedPermissions = requestedPermissionsCallback(args);
    const {
      hasPermissions
    } = await args.dispatch(entitiesResource.getEntityPermissions(requestedPermissions.entity));
    if (wrappedPreFetch) {
      await wrappedPreFetch({
        ...args,
        permissions: Object.entries(requestedPermissions.hasPermissions).reduce((acc, [key, permissions]) => {
          acc[key] = hasPermissions(permissions);
          return acc;
        }, args.permissions || {})
      });
    }
    return null;
  };
  return HoistedComponent;
};